export const getButterCmsPage = (pageName) => {
    const butter = require('buttercms')('6a1c0e28aeba5c9e46b9f4b707b4d42b3b2592a1');
    return butter.page.retrieve('*',
        pageName,
        {
            'preview': process.env.VUE_APP_ENV === 'Production' ? 0 : 1,
            'locale': 'en',
        },
    ).then((resp) => resp?.data?.data?.fields?.section)
        .catch(error => console.error(error));
};
